export default "/images/88172091b88550aad7f3301b1a6f74e3.avif";